module.exports = __webpack_public_path__ + "static/img/group_honor2.914709fd.png";